import React from 'react';
import { useTranslation } from 'react-i18next';
import { Truck, ExternalLink } from 'lucide-react';

/** Carrier + tracking number of an order's dispatch (never the shipping cost the store paid). */
const ShipmentTracking = ({ shipment, className = '' }) => {
  const { t } = useTranslation();
  if (!shipment?.trackingNumber) return null;
  return (
    <div className={`bg-white rounded-lg shadow-sm p-6 ${className}`}>
      <h2 className="text-lg font-semibold text-[#2C2420] mb-4 flex items-center gap-2">
        <Truck className="h-5 w-5 text-[#be1f1a]" />
        {t('shipmentTracking.title')}
      </h2>
      <dl className="grid sm:grid-cols-2 gap-4 text-sm">
        <div>
          <dt className="text-gray-600">{t('shipmentTracking.carrier')}</dt>
          <dd className="font-medium text-[#2C2420]">{shipment.service || shipment.carrier}</dd>
        </div>
        <div>
          <dt className="text-gray-600">{t('shipmentTracking.trackingNumber')}</dt>
          <dd className="font-mono font-medium text-[#2C2420] break-all">{shipment.trackingNumber}</dd>
        </div>
      </dl>
      {shipment.trackUrl && (
        <a
          href={shipment.trackUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 mt-4 text-[#be1f1a] font-medium hover:underline"
        >
          {t('shipmentTracking.trackPackage')}
          <ExternalLink className="h-4 w-4" />
        </a>
      )}
    </div>
  );
};

export default ShipmentTracking;
